import Logo from "./Logo";
import LanguageSwitcher from "../../languageSwitcher/LanguageSwitcher";

const PublicHeader = () => {
  return (
    <header className="flex h-26 flex-row items-center justify-center bg-white p-6">
      <Logo />
      <LanguageSwitcher className="absolute right-8" compact />
    </header>
  );
};

export default PublicHeader;
